import { type DERC, type DERCRequest, type DERCResponse, type DERCFiltered } from '../types/derc';
import { http } from '../../../../api/http';

export class DERCService {
  private static readonly ENDPOINTS = {
    LIST: '/Documento',
    FILTERED_LIST: '/Documento/filtered-list',
    CREATE: '/Documento',
    GET_BY_ID: '/Documento',
    UPDATE: '/Documento',
    DELETE: '/Documento',
  };

  public static async getDERCs(): Promise<DERC[]> {
    try {
      const response = await http.get(this.ENDPOINTS.LIST);
      return response.data;
    } catch (error) {
      console.error('Error fetching DERCs:', error);
      throw error;
    }
  }

  public static async getFilteredDERCs(): Promise<DERCFiltered[]> {
    try {
      const response = await http.get(this.ENDPOINTS.FILTERED_LIST);
      return response.data;
    } catch (error) {
      console.error('Error fetching filtered DERCs:', error);
      throw error;
    }
  }

  public static async saveDERC(dercRequest: DERCRequest): Promise<DERC> {
    try {
      const isUpdate = !!dercRequest.id;

      console.log(`${isUpdate ? 'Updating' : 'Creating'} DERC:`, {
        url: this.ENDPOINTS.CREATE,
        method: 'POST',
        isUpdate,
        data: dercRequest
      });

      const response = await http.post(this.ENDPOINTS.CREATE, dercRequest);

      console.log(`DERC ${isUpdate ? 'updated' : 'created'} successfully:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error ${dercRequest.id ? 'updating' : 'creating'} DERC:`, error);
      throw error;
    }
  }

  // Keep the old method name for backward compatibility
  public static async createDERC(dercRequest: DERCRequest): Promise<DERC> {
    return this.saveDERC(dercRequest);
  }

  public static async updateDERC(dercRequest: DERCRequest): Promise<DERC> {
    if (!dercRequest.id) {
      throw new Error('DERC ID is required for update');
    }
    return this.saveDERC(dercRequest);
  }

  public static async getDERCById(id: number): Promise<DERCResponse> {
    try {
      const response = await http.get(`${this.ENDPOINTS.GET_BY_ID}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching DERC by id:', error);
      throw error;
    }
  }

  public static async deleteDERC(id: number): Promise<void> {
    try {
      console.log('Deleting DERC:', { id, url: `${this.ENDPOINTS.DELETE}/${id}` });

      await http.delete(`${this.ENDPOINTS.DELETE}/${id}`);

      console.log('DERC deleted successfully:', id);
    } catch (error) {
      console.error('Error deleting DERC:', error);
      throw error;
    }
  }

  public static async toggleDERCStatus(id: number): Promise<DERC> {
    try {
      console.log('Toggling DERC status:', { id });

      const response = await http.patch(`${this.ENDPOINTS.UPDATE}/${id}/toggle-status`);

      console.log('DERC status toggled successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error toggling DERC status:', error);
      throw error;
    }
  }


}